import { render, staticRenderFns } from "./Renew.vue?vue&type=template&id=a1983bc2&scoped=true"
import script from "./Renew.vue?vue&type=script&lang=js"
export * from "./Renew.vue?vue&type=script&lang=js"
import style0 from "./Renew.vue?vue&type=style&index=0&id=a1983bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1983bc2",
  null
  
)

export default component.exports